import { useCallback, useEffect, useState } from 'react';
import { clearRecentActivity, getRecentActivity, getSearchSources } from '@/api/smartSearch';

// What the panel needs once it opens: the sources this person may search (read once) and their own recent activity
// (re-read on every open, so renamed records show their new name and deleted ones are gone).
export default function useSmartSession(open) {
  const [sources, setSources] = useState(null);
  const [minChars, setMinChars] = useState(2);
  const [recents, setRecents] = useState(null);

  useEffect(() => {
    if (!open || sources) return;
    getSearchSources().then((d) => { setSources(d.sources || []); setMinChars(d.min_chars || 2); }).catch(() => setSources([]));
  }, [open, sources]);

  useEffect(() => {
    if (!open) return;
    setRecents(null);
    getRecentActivity().then(setRecents).catch(() => setRecents([]));
  }, [open]);

  const clear = useCallback(async () => {
    const before = recents;
    setRecents([]);
    try { await clearRecentActivity(); } catch { setRecents(before); }
  }, [recents]);

  return { sources: sources || [], minChars, recents, clear };
}
